module.exports = __webpack_public_path__ + "/hashedassets-launcher/v3/disclaimer_warning.6bd20401a79898b5ce9bc6174bc0bc78.svg";